﻿import { Component, OnInit} from '@angular/core';


@Component({ templateUrl: 'recibir.component.html' })
export class RecibirComponent implements OnInit {

    constructor() {
    }


    ngOnInit() {
    }



}
